import styled from 'styled-components'
import colors from 'globals/colors'

export const ClientInfo = styled.div`
  line-height: 19px;
  color: ${colors.steelGrey};
  font-size: 14px;
  margin-bottom: 23px;
  
  & > b {
    color: ${colors.darkGrey};
    font-weight: 600;
    & > button {
      margin-left: 10px;
      border: none;
      background: none;
      &:hover {
        cursor: pointer;
      }
    }

  }
  
  & > span {
    font-weight: 600;
  }
`

export const HorizontalWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  & > div {
    width: 50%;
  }
`
